"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twMerge = void 0;
exports.createTwMerge = createTwMerge;
const tailwind_merge_1 = require("tailwind-merge");
function createTwMerge(prefix) {
    return (0, tailwind_merge_1.extendTailwindMerge)({ prefix });
}
exports.twMerge = createTwMerge("ko");
